/* tslint:disable */
/* eslint-disable */
/**
 * Streem API
 * The Streem API gives you access to information captured during Streem calls.  You can retrieve artifacts such as recordings, streemshots (including captured model/serial numbers), and much more.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: support@streem.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
export function StreemApiArtifactStreemshotDepthMapFromJSON(json) {
    return StreemApiArtifactStreemshotDepthMapFromJSONTyped(json, false);
}
export function StreemApiArtifactStreemshotDepthMapFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'streemshotSid': !exists(json, 'streemshot_sid') ? undefined : json['streemshot_sid'],
        'storageUrl': !exists(json, 'storage_url') ? undefined : json['storage_url'],
        'url': !exists(json, 'url') ? undefined : json['url'],
        'deletedAt': !exists(json, 'deleted_at') ? undefined : (new Date(json['deleted_at'])),
    };
}
export function StreemApiArtifactStreemshotDepthMapToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'streemshot_sid': value.streemshotSid,
        'storage_url': value.storageUrl,
        'url': value.url,
        'deleted_at': value.deletedAt === undefined ? undefined : (value.deletedAt.toISOString()),
    };
}
//# sourceMappingURL=StreemApiArtifactStreemshotDepthMap.js.map